<template>
    <div :class="`card card-activity-log ${ classForStatus }`">
            <div class="activity-type-col">
                <i :class="`far fa-fw ${iconForActivityType}`"></i>
            </div>
            <div class="activity-content">
                <div class="row">
                    <div class="col-xl-2">
                        <strong>{{ titleLabelTitle }}:</strong>
                    </div>
                    <div class="col-xl-10">
                        <p>{{ activity.title }}</p>
                    </div>
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-xl-6" v-if="shouldShowDueDate">
                        <div class="row">
                            <div class="col-xl-4">
                                <strong>{{ dueDateLabelTitle }}:</strong>
                            </div>
                            <div class="col-xl-8">
                                <p>{{ activity.due_date | moment('DD/MM/YYYY') }}</p>
                            </div>
                        </div><!-- /.row -->
                    </div>
                    <div class="col-xl-6" v-if="shouldShowAchievedDate">
                        <div class="row" >
                            <div class="col-xl-4">
                                <strong>{{ achievedDateLabelTitle }}:</strong>
                            </div>
                            <div class="col-xl-8">
                                <p>{{ activity.achieved | moment('DD/MM/YYYY') }}</p>
                            </div>
                        </div><!-- /.row -->
                    </div>
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-xl-2">
                        <strong>Status:</strong>
                    </div>
                    <div class="col-xl-10">
                        <p>{{ titleForStatus }}</p>
                    </div>
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-xl-2">
                        <strong>Content:</strong>
                    </div>
                    <div class="col-xl-10">
                        <p style="white-space: pre-wrap;">{{ activity.content }}</p>
                    </div>
                </div><!-- /.row -->

                <small>Added by {{ activity.created_by.name }} {{ activity.created_at }}</small>
            </div>
            <div class="activity-actions">
                <div class="dropdown">
                    <button class="btn" type="button" id="dropdownMenuButton" v-dropdown aria-haspopup="true" aria-expanded="false">
                        <i class="far fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a href="#" v-if="shouldShowDelayButton" @click.prevent="handleReschedule" class="dropdown-item">Re-Schedule</a>
                        <a href="#" v-if="shouldShowDelayButton" @click.prevent="handleCancel" class="dropdown-item">Cancelled</a>
                        <a href="#" v-if="shouldShowDelayButton" @click.prevent="handleComplete" class="dropdown-item">Complete</a>
                        <a href="#" @click.prevent="handleEdit(activity)" class="dropdown-item">Edit</a>
                        <a href="#" @click.prevent="handleDelete" class="dropdown-item">Delete</a>
                    </div>
                </div>
            </div><!-- /.activity-actions -->
        </div>
</template>

<script>
import { activityLog } from 'mixins'
import { notify } from 'utils'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { LaddaButton } from 'components/form/input'
import Datepicker from 'vuejs-datepicker'

export default {
    $_veeValidate: {
        validator: 'new' // give me my own validator scope.
    },

    props: ['activity'],

    mixins: [activityLog],

    components: {
        LaddaButton,
        Datepicker
    },

    data () {
        return {
            achievedDate: null,
        }
    },

    computed: {
        ...mapState('project', ['project']),
    },

    methods: {
        ...mapActions('projects/activityLog', ['deleteActivityLogItem', 'updateStatusForActivityLogItem']),

        handleDelete() {
            this.$swal(
        		{
                    title: 'Confirm Delete',
                    html: `Are you sure you want to delete this activity log item?`,
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        let payload = {
                            projectId: this.project.id,
                            id: this.activity.id
                        }

                        return this.deleteActivityLogItem(payload).then((response) => {

                            notify.success('Successfully deleted activity item.')

                        }).catch((error) => {
                            this.$swal.close()
                            notify.error('Failed to create activity log item, please try again.')
                        })
                    }
        		})
        },

        handleEdit(activity) {
            this.$emit('edit-activity-log-item', activity)
        },

        handleReschedule() {
            return this.handleSetStatus('rescheduled')
        },

        handleCancel() {
            return this.handleSetStatus('cancelled')
        },

        handleComplete() {
            return this.handleSetStatus('completed')
        },

        async handleSetAchievedDate() {
            if (!await this._validate()) {
                notify.error('Form validation failed, please check your inputs and try again.')
                return Promise.reject()
            }

            let payload = {
                projectId: this.project.id,
                id: this.activity.id,
                payload: {
                    achieved: this.achievedDate ? moment(this.achievedDate).format('YYYY-MM-DD') : null
                }
            }

            return this.updateStatusForActivityLogItem(payload)
        },

        handleSetStatus(status) {
            let payload = {
                projectId: this.project.id,
                id: this.activity.id,
                payload: {
                    status: status
                }
            }

            return this.updateStatusForActivityLogItem(payload)
        }
    }
}
</script>
